import { lazy } from "react";
export const ImageComponent = lazy(() => import("./Image"));
export const Grid = lazy(() => import("./grid"));
export const Row = lazy(() => import("./row"));
export const Column = lazy(() => import("./column"));
export const Label = lazy(() => import("./label"));
export const Button = lazy(() => import("./button"));
export const Container = lazy(() => import("./container"));
export const TextView = lazy(() => import("./textview"));
export const Center = lazy(() => import("./center"));
export const Link = lazy(() => import("./Link"));
export const Space = lazy(() => import("./space"));
export const Loader = lazy(() => import("./Loader"));
export const Globalloader = lazy(() => import("./globalLoader"));
export const Form = lazy(() => import("./form"));
export const AnimatedDiv = lazy(() => import("./AnimatedDiv"));
export const Passwordvalidation = lazy(() => import("./validatePassword"));
export const PopupBuilder = lazy(() => import("./PopupBuilder"));
export const Popup = lazy(() => import("./Popup"));
export const Toast = lazy(() => import("./toast"));
export const Carousel = lazy(() => import("./carousel"));
export const Productitem = lazy(() => import("./product"));
export const Distributor = lazy(() => import("./distributor"));
export const Tab = lazy(() => import("./tab"));
export const Backbutton = lazy(() => import("./backButton"));
export const ServerUnavailable = lazy(() => import("./errorMessage"));
export const Drawer = lazy(() => import("./Drawer"));
export const DragAndDropList = lazy(() => import("./DragAndDropList"));
export const FloatingTextField = lazy(() => import("./floadingInput"));
export const ScrollEndDetector = lazy(() => import("./ScrollEndDetector"));



















